import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import StyledNotifications from './Notification.styled';
import Notification from './Notification.component';
import { hideNotification, clearNotifications } from '../../../../../shared/components/common/Dialogs/Dialogs.actions';

class NotificationContainer extends React.Component {

  closeWaitingList = new Set();

  componentDidUpdate(prevProps) {
    if (this.props.notifications !== prevProps.notifications) {
      const newNotificationsWithCloseDelay = this.props.notifications
        .filter(n => !!n.closeDelay)

      newNotificationsWithCloseDelay.forEach(({ id, closeDelay }) => {
        if (!this.closeWaitingList.has(id)) {
          this.closeWaitingList.add(id);
          setTimeout(() => {
            this.props.clickClose(id);
            this.closeWaitingList.delete(id);
          }, closeDelay)
        }
      })
    }
  }

  render() {
    const { notifications, clearAll, clickClose } = this.props;

    return (
      !notifications.length ? null :
        <StyledNotifications>
          <div className="tools">
            {notifications.length < 2 ? null : (
              <a href="#" onClick={clearAll}>
                <FormattedMessage id="actions.remove_all" />
              </a>
            )}
          </div>
          <div aria-live="polite">
            {notifications.map((item) =>
              <Notification
                item={item}
                key={item.id}
                clickClose={() => clickClose(item.id)} 
              />
            )}
          </div>
        </StyledNotifications>
    )
  }
}

const mapStateToProps = ({ dialogs }) => ({
  notifications: dialogs.notifications
});

const mapDispatchToProps = (dispatch) => ({
  clickClose(id) {
    dispatch(
      hideNotification(id)
    );
  },
  clearAll(e) {
    e.preventDefault();

    dispatch(
      clearNotifications()
    );
  }
});

NotificationContainer.propTypes = {
  clickClose: PropTypes.func,
  clearAll: PropTypes.func,
  notifications: PropTypes.array
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationContainer);
